import request from '@/utils/request'
// 菜单页
// 获取列表数据
export function pageList(params) {
  return request({
    url: '/v3/user/menuV3/pageList',
    method: 'post',
    data: params
  })
}
// 新增菜单--提交
export function insert(params) {
  return request({
    url: '/v3/user/menuV3/insert',
    method: 'post',
    data: params
  })
}
// 删除一条数据
export function deleteById(params) {
  return request({
    url: '/v3/user/menuV3/deleteById',
    method: 'post',
    data: params
  })
}
// 删除多条数据
export function deleteByIds(params) {
  return request({
    url: '/v3/user/menuV3/deleteByIds',
    method: 'post',
    data: params
  })
}
// role页
// 获取列表数据
export function rolePageList(params) {
  return request({
    url: '/v3/user/roleV3/pageList',
    method: 'post',
    data: params
  })
}
// 删除--单个
export function roleDeleteById(params) {
  return request({
    url: '/v3/user/roleV3/deleteById',
    method: 'post',
    data: params
  })
}
// 删除--多个
export function roleDeleteByIds(params) {
  return request({
    url: '/v3/user/roleV3/deleteByIds',
    method: 'post',
    data: params
  })
}
// 新增菜单--提交
export function roleInsert(params) {
  return request({
    url: '/v3/user/roleV3/insert',
    method: 'post',
    data: params
  })
}
// 编辑菜单--提交
export function update(params) {
  return request({
    url: '/v3/user/roleV3/update',
    method: 'post',
    data: params
  })
}
// 编辑菜单--获取权限
export function getPermission(params) {
  return request({
    url: '/v3/user/roleV3/getPermission',
    method: 'post',
    data: params
  })
}
// 编辑菜单--获取菜单
export function getMenuIdsByRoleId(params) {
  return request({
    url: '/v3/user/roleV3/getMenuIdsByRoleId',
    method: 'post',
    data: params
  })
}
// 菜单按钮--列表
export function insertListBtn(params) {
  return request({
    url: '/v3/user/yhubManageButton/list',
    method: 'post',
    data: params
  })
}
// 新增菜单按钮--新增提交
export function insertAddBtn(params) {
  return request({
    url: '/v3/user/yhubManageButton/insert',
    method: 'post',
    data: params
  })
}
// 新增菜单按钮--编辑提交
export function updateByPrimaryKey(params) {
  return request({
    url: '/v3/user/yhubManageButton/updateByPrimaryKey',
    method: 'post',
    data: params
  })
}
// 新增菜单按钮--删除
export function deleteByPrimaryKey(params) {
  return request({
    url: '/v3/user/yhubManageButton/deleteByPrimaryKey',
    method: 'post',
    data: params
  })
}
